import { useContext } from 'react';
import DressingRoomContext from '../contexts/DressingRoomContext';

const useDressingRoomContext = () => useContext(DressingRoomContext);

export default useDressingRoomContext;
